import { useEffect } from 'react';
import { Text, Image, useBreakpointValue } from '@chakra-ui/react';
import { ICON_BY_NAME } from 'ui/components/Icons/Icon';
import styles from './FileChip.module.css';
import { NewsfeedItemFile } from 'types/NewsfeedItem';
import { LinkIcon } from '@chakra-ui/icons';
interface Props {
  file: NewsfeedItemFile | File;
  removeFile?: (file: NewsfeedItemFile | File) => void;
}
export const FileChip = ({
  file,
  removeFile
}: Props) => {
  const isImage = file.type.startsWith('image/');
  const typeDisplayName = file.type.split('/')[1];
  const IconComponent = ICON_BY_NAME[typeDisplayName] || LinkIcon;
  const isMobile = useBreakpointValue({
    base: true,
    sm: false
  }, {
    ssr: false
  });
  const fileUrl = file instanceof File ? URL.createObjectURL(file) : file.url;
  useEffect(() => {
    return () => {
      if (file instanceof File) {
        URL.revokeObjectURL(fileUrl);
      }
    };
  });
  const handleDelete = e => {
    if (removeFile) {
      removeFile(file);
    }
    e.stopPropagation();
    e.preventDefault();
  };
  return <a href={fileUrl} target="_blank" data-sentry-component="FileChip" data-sentry-source-file="FileChip.tsx">
      <div className={`${styles.fileChip} ${isMobile ? styles.fileChipSmall : ''}`}>
        <div className={styles.fileChipContent}>
          <div className={styles.fileChipPreview}>
            {isImage ? <Image src={fileUrl || ''} fit="contain" /> : <IconComponent width={'36px'} height={'36px'} />}
          </div>
          <div className={styles.fileChipDescription}>
            <Text fontWeight="800" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" maxWidth="200px" data-sentry-element="Text" data-sentry-source-file="FileChip.tsx">
              {file.name}
            </Text>
            <Text whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" maxWidth="200px" data-sentry-element="Text" data-sentry-source-file="FileChip.tsx">
              {typeDisplayName.toUpperCase()}
            </Text>
          </div>
        </div>
        {removeFile ? <div className={styles.remove}>
            <ICON_BY_NAME.close height="16px" width="16px" onClick={handleDelete} />
          </div> : <div />}
      </div>
    </a>;
};